/** @format */

export enum SubmissionErrorCode {
    UNHANDLED_EXCEPTION = '000',
    VALIDATION = '001',
    PRODUCT_ASSIGNED = '002',
    PRODUCT_ALLOCATION = '003',
    INVALID_CSRF = '004',
    DUPLICATE_OPERATION = '005',
    TOKEN_EXPIRED = '006',
    INVALID_TOKEN = '007',
    INCONSISTENT_MARKET = '008',
    PAYMENT_GATEWAY = '009',
    BAD_TX_STATE = '010',
    TERMS_FLAG_MISSING = '011',
    PERMISSION_DENIED = '012',
    UNVERIFIED_ACCOUNT = '013',
    AUTH_FAILED = '014',
    DUPLICATE = '015',
    INVALID_BARCODE = '016',
    BASKET_MAX_ITEM_LIMIT_REACHED = '017',
}
